import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ApplicantCard from "./ApplicantCard";
import ApplicantProfile from "./ApplicantProfile";
import Card from "components/card";
import EmptyCandidates from "./EmptyCandidate";
import SearchBar from "components/search/SearchBar";
import { Pagination} from "antd";
import { 
	getRegisteredApplicants
} from "../../../../redux/recruitment/recruitmentState";
import { displayIcon } from "variables/icons";

const RegisteredApplicants = () => {

    const dispatch = useDispatch();

    const recordList = useSelector((state) => state.recruitment.registeredApplicants?.items);
    const pagination = useSelector((state) => state.recruitment.registeredApplicants?.pagination);
	const filters = useSelector((state) => state.recruitment.registeredApplicants?.filters);
  	const requesting = useSelector((state) => state.recruitment.registeredApplicants?.requesting);
  	const error = useSelector((state) => state.recruitment.registeredApplicants?.error);

    const doSearchApplicants = (data) => dispatch(getRegisteredApplicants(data));

    const [selected, setSelected] = useState(null);

    useEffect(() => {
        doSearchApplicants({paginate: pagination.per_page});
        setSelected(null);
    }, [dispatch]);

    const handlePageChange = (page, pageSize) => {
        doSearchApplicants({
            ...filters,
            page,
            paginate: pageSize,
        });
    };
    
    return (
        <div className="flex flex-col">
            <div className="space-y-6">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                    <div className="col-span-2">
                        <Card className="flex flex-col gap-6 rounded-2xl shadow-sm bg-white border-2 border-slate-200">
                            <div className="bg-gradient-to-br from-emerald-50 to-cyan-50 border-b rounded-t-2xl p-6 grid items-start gap-1.5">
                                <div className="flex items-center justify-between gap-2">
                                    <div className="min-w-0">
                                        <h4 className="text-[18px]">
                                            Registered Applicants
                                        </h4>
                                    </div>
                                    <span className="inline-flex items-center justify-center w-6 h-6 rounded-lg px-2 py-0.5 font-medium  bg-gradient-to-br from-emerald-500 to-cyan-500 text-white text-[13px] flex-shrink-0">
                                        {recordList?.length }
                                    </span>
                                </div>
                            </div>
                            
                            <div className="p-6 pt-2 space-y-3">
                                <SearchBar
                                    placeholder="Search applicants..." 
                                    searchHandler={doSearchApplicants}
                                    filters={filters}
                                />
                                <div className="grid grid-cols-1 gap-4">
                                    {recordList?.length === 0 ? (
                                        <EmptyCandidates />
                                    ) : (
                                        <>
                                        {recordList?.map((applicant) => (
                                            <ApplicantCard
                                                key={applicant.id}
                                                recordData={applicant}
                                                {...applicant}
                                                selected={selected?.id === applicant.id}
                                                onClick={() => setSelected(applicant)}
                                                stage={applicant.stage}
                                            />
                                        ))
                                        }
                                        <div className="flex justify-end mt-2">
                                            <Pagination
                                                current={pagination?.current_page}
                                                pageSize={pagination?.per_page}
                                                total={pagination?.total}
                                                showSizeChanger={false}
                                                onChange={handlePageChange}
                                            />
                                        </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </Card>
                    </div>
                    <div className="hidden lg:block">
                        {selected ? (
                            <ApplicantProfile 
                                applicant={selected} 
                            />
                            ) : (
                            <div className="flex flex-col items-center justify-center h-[200px] text-gray-500 text-sm bg-white border-2 rounded-xl border-slate-300 border-dashed pb-6 px-4 py-12 text-center dark-mode-card">
                                {displayIcon('Users', "w-12 h-12 text-gray-800 mb-3 dark:text-white")}
                                <h4 className="text-[14px] font-semibold mb-2 dark:text-white">
                                    No Candidate Selected
                                </h4>
                                <p className="text-[12px] max-w-xs dark:text-slate-100">
                                    Select a applicant from the list to view their details and progress
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisteredApplicants;